import { render, staticRenderFns } from "./WsContent.vue?vue&type=template&id=44fd723a&"
import script from "./WsContent.vue?vue&type=script&lang=js&"
export * from "./WsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports